import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@mui/material";
import {
  ExpandMore,
  FlagOutlined,
  StarOutlined,
  ImportExportOutlined,
  FormatListNumberedOutlined,
  MapOutlined,
} from "@mui/icons-material";
import { regions } from "../../data";
import * as api from "../../api";

const Highscores = () => {
  const [user, setUser] = useState(null);
  const [expanded, setExpanded] = useState("panel0");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    const getUser = async () => {
      let { data } = await api.getUser(localStorage.getItem("userid"));

      if (data[0]) {
        setUser(data[0]);
      }
    };
    getUser();
  }, []);

  const classes = useStyles();

  const accordionContent = [
    {
      name: "Flags",
      component: (
        <TableContainer
          sx={{
            width: { xs: "100%", sm: "70%" },
            margin: "auto",
            backgroundColor: "background.paper",
            border: "1px solid white",
            padding: "0",
          }}
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCellLeft}
                  sx={{ fontWeight: "bold" }}
                >
                  Region
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Multiple Choice
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Type Answer
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {regions.map((region) => {
                return (
                  <TableRow>
                    <TableCell className={classes.tableCellLeft}>
                      {region}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Flags["Multiple Choice"][region] : "-"}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Flags["Type Answer"][region] : "-"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ),
      icon: (
        <FlagOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "Capitals",
      component: (
        <TableContainer
          sx={{
            width: { xs: "100%", sm: "70%" },
            margin: "auto",
            backgroundColor: "background.paper",
            border: "1px solid white",
            padding: "0",
          }}
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCellLeft}
                  sx={{ fontWeight: "bold" }}
                >
                  Region
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Multiple Choice
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Type Answer
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {regions.map((region) => {
                return (
                  <TableRow>
                    <TableCell className={classes.tableCellLeft}>
                      {region}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user
                        ? user.stats.Capitals["Multiple Choice"][region]
                        : "-"}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Capitals["Type Answer"][region] : "-"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ),
      icon: (
        <StarOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "HighLow",
      component: (
        <TableContainer
          sx={{
            width: { xs: "100%", sm: "70%" },
            margin: "auto",
            backgroundColor: "background.paper",
            border: "1px solid white",
            padding: "0",
          }}
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCellLeft}
                  sx={{ fontWeight: "bold" }}
                >
                  Region
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Population
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Area
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Density
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {regions.map((region) => {
                return (
                  <TableRow>
                    <TableCell className={classes.tableCellLeft}>
                      {region}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Highlow.Population[region] : "-"}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Highlow.Area[region] : "-"}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Highlow.Density[region] : "-"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ),
      icon: (
        <ImportExportOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "Lists",
      component: (
        <TableContainer
          sx={{
            width: { xs: "100%", sm: "70%" },
            margin: "auto",
            backgroundColor: "background.paper",
            border: "1px solid white",
            padding: "0",
          }}
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCellLeft}
                  sx={{ fontWeight: "bold" }}
                >
                  Region
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Countries
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {regions.map((region) => {
                return (
                  <TableRow>
                    <TableCell className={classes.tableCellLeft}>
                      {region}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Lists[region] : "-"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ),
      icon: (
        <FormatListNumberedOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "Maps",
      component: (
        <TableContainer
          sx={{
            width: { xs: "100%", sm: "70%" },
            margin: "auto",
            backgroundColor: "background.paper",
            border: "1px solid white",
            padding: "0",
          }}
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCellLeft}
                  sx={{ fontWeight: "bold" }}
                >
                  Region
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  sx={{ fontWeight: "bold" }}
                >
                  Countries
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {regions.map((region) => {
                return (
                  <TableRow>
                    <TableCell className={classes.tableCellLeft}>
                      {region}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {user ? user.stats.Maps[region] : "-"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ),
      icon: (
        <MapOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
  ];
  return user ? (
    <Box
      sx={{
        width: { xs: "95%", sm: "70%", md: "50%", lg: "40%" },
        margin: "auto",
      }}
    >
      {accordionContent.map((game, idx) => {
        return (
          <Accordion
            elevation={10}
            key={game.title}
            expanded={expanded === `panel${idx}`}
            onChange={handleChange(`panel${idx}`)}
          >
            <AccordionSummary
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                height: "42px",
              }}
              expandIcon={<ExpandMore />}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                {game.icon}
              </Box>
              <Typography
                variant="overline"
                sx={{
                  margin: "auto",
                  fontWeight: { xs: "500", md: "700" },
                  fontSize: { xs: "18px", sm: "22px" },
                  color: "RGBA(5,15,0,0.74)",

                  textAlign: "center",
                }}
              >
                {game.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{ backgroundColor: "background.default", padding: "1rem 0" }}
            >
              {game.component}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  ) : (
    <Typography sx={{ width: "50%", margin: "2rem auto", textAlign: "center" }}>
      Please sign in to view your highscores.
    </Typography>
  );
};

export default Highscores;
